// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".embed-warning {\n  text-align: center;\n  font-size: 12px;\n  background-color: rgb(255, 100, 100);\n}\n", "",{"version":3,"sources":["/apps/proksee/project/releases/20250624162016/app/javascript/proksee-viewer/tools/assemble/components/IcarusCard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,oCAAoC;AACtC","file":"IcarusCard.css","sourcesContent":[".embed-warning {\n  text-align: center;\n  font-size: 12px;\n  background-color: rgb(255, 100, 100);\n}\n"]}]);
// Exports
module.exports = exports;
